import { render, staticRenderFns } from "./qChatCarpsale.vue?vue&type=template&id=e39858d0&scoped=true&"
import script from "./qChatCarpsale.vue?vue&type=script&lang=ts&"
export * from "./qChatCarpsale.vue?vue&type=script&lang=ts&"
import style0 from "./qChatCarpsale.vue?vue&type=style&index=0&id=e39858d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39858d0",
  null
  
)

export default component.exports